/* cf-endpost-draw.js - Click Fencing, 2026-09-01 (later session)
 *
 * Pete: "on perfmesh when there is a rake panel the no post option doesnt remove the post
 *        in the graphics but it does remove it from the order. it needs to be removed on
 *        the graphics"
 *
 * MEASURED on the live PerfMesh calculator - 8725mm, 2000mm sheets, raked, Side End Post
 * Setup = "No Post Left":
 *
 *     drawn   6 posts   rect[width=8] at x = 0, 150, 338, 526, 714, 838
 *     billed  5 posts   "Base Mount Post (50mm) x5"
 *
 * The post at x=0 is the one the customer asked NOT to have. The solver already dropped it
 * from the bill; only the renderer still draws it. So the picture the customer approves
 * shows a post they are not buying and will not receive - and on a fence that butts up to
 * a wall, that post is exactly the thing they were avoiding.
 *
 * HOW A POST IS DRAWN. Three elements per post, all in the section preview SVG:
 *     the post      <rect width="8"  fill="#1a1a1a">        (height varies; a raked end
 *                                                            post is taller than the rest)
 *     its footing   <rect width="18" height="6" y="214">    centred 5px left of the post
 *     its label     <text>50</text>                          ~4px right of the post's x
 *
 * WHY THIS IS SAFE - IT ONLY EVER ACTS ON A PROVEN EXCESS. It does not assume the renderer
 * is wrong. It counts the posts DRAWN and the posts BILLED, and only hides an end post when
 *
 *     end post setup is not "both"   AND   drawn > billed
 *
 * If a calculator already draws the end posts correctly, drawn === billed and this does
 * nothing at all. That matters because blade, flat top and PerfMesh share the same control
 * and this runs on all three - the check, not a guess about which one is broken, decides.
 *
 * Hides rather than removes, so a redraw restores the original and the next pass re-hides.
 * Display only: no price, product, quantity or cart line is touched. The bill was already
 * right; it is the drawing that was lying.
 */
(function () {
  'use strict';

  if (window.__cfEndPostDraw) return;
  window.__cfEndPostDraw = true;

  var PATHS = [
    '/pages/perfmesh-fence',
    '/pages/blade-fence-calculator',
    '/pages/flat-top-fence-calculator',
    '/pages/base-mount-batten-calculator'
  ];
  var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  if (PATHS.indexOf(path) === -1) return;

  var MARK = 'data-cf-endpost-hidden';

  function inst() { return window.glassCalculator || window.glassFencingCalculator || null; }

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }

  /* Posts billed on the CURRENT quote. Counts every line that names a post, so an
     "In-Ground Raked Post" counts alongside "In-Ground Post". */
  function billedPosts() {
    try {
      var c = inst();
      var bd = c && c.state && c.state.quoteBreakdown;
      if (Object.prototype.toString.call(bd) !== '[object Array]') return null;
      var total = 0, found = false;
      bd.forEach(function (b) {
        var item = String((b && b.item) || '');
        if (!/\bposts?\b/i.test(item)) return;
        found = true;
        total += Math.max(0, Math.floor(Number(b.quantity) || 0));
      });
      return found ? total : null;
    } catch (e) { return null; }
  }

  /* Which end(s) the customer asked to go without. Reads the real select. */
  function endSetup() {
    var els = document.querySelectorAll('[id$="-end-post-setup"]');
    for (var i = 0; i < els.length; i++) {
      var v = String(els[i].value || '').trim();
      if (v && v !== 'both') return v;      // no-left | no-right | no-both
    }
    return 'both';
  }

  function svg() { return document.querySelector('#section-preview svg'); }

  function restore(root) {
    try {
      [].forEach.call(root.querySelectorAll('[' + MARK + ']'), function (el) {
        el.style.removeProperty('display');
        el.removeAttribute(MARK);
      });
    } catch (e) {}
  }

  function hide(el) {
    if (!el) return;
    el.setAttribute(MARK, '1');
    el.style.setProperty('display', 'none', 'important');
  }

  /* The post rect, its footing and its label, as one group. */
  function hidePostAt(root, post) {
    hide(post);
    var px = num(post.getAttribute('x'));
    if (px === null) return;

    [].forEach.call(root.querySelectorAll('rect'), function (r) {
      if (r === post) return;
      var w = num(r.getAttribute('width')), h = num(r.getAttribute('height'));
      var x = num(r.getAttribute('x'));
      if (w === 18 && h === 6 && x !== null && Math.abs(x - (px - 5)) <= 6) hide(r);
    });

    [].forEach.call(root.querySelectorAll('text'), function (t) {
      var x = num(t.getAttribute('x'));
      if (x === null) return;
      if (/^\s*50\s*$/.test(t.textContent || '') && Math.abs(x - (px + 4)) <= 8) hide(t);
    });
  }

  function apply() {
    try {
      var root = svg();
      if (!root) return;

      restore(root);

      var setup = endSetup();
      if (setup === 'both') return;

      var billed = billedPosts();
      if (billed === null) return;

      var posts = [].slice.call(root.querySelectorAll('rect')).filter(function (r) {
        return num(r.getAttribute('width')) === 8 &&
               /^#1a1a1a$/i.test(String(r.getAttribute('fill') || ''));
      }).sort(function (a, b) { return num(a.getAttribute('x')) - num(b.getAttribute('x')); });

      var excess = posts.length - billed;
      if (excess <= 0) return;   /* drawn already matches the bill - nothing to do */

      if (setup === 'no-both') {
        if (posts.length >= 2 && excess >= 2) {
          hidePostAt(root, posts[0]);
          hidePostAt(root, posts[posts.length - 1]);
        } else if (posts.length >= 1) {
          hidePostAt(root, posts[0]);
        }
      } else if (setup === 'no-left') {
        hidePostAt(root, posts[0]);
      } else if (setup === 'no-right') {
        hidePostAt(root, posts[posts.length - 1]);
      }
    } catch (e) {
      if (window.console && console.debug) console.debug('[cf-endpost-draw]', e);
    }
  }

  var t = null;
  function schedule() { if (t) clearTimeout(t); t = setTimeout(apply, 140); }

  function start() {
    apply();
    try {
      var host = document.getElementById('section-preview') ||
                 document.querySelector('.calculator-page') || document.body;
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
      }
      document.addEventListener('change', schedule, true);
      window.addEventListener('resize', schedule);
    } catch (e) {}
    var n = 0;
    (function tick() { if (n++ > 80) return; apply(); setTimeout(tick, 600); })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
